import { ApiUrls } from "../endpoints";
import axios, { AxiosError, AxiosResponse } from "axios";
import { BatchCloseOutSummaryResponse, BatchReportResponse, EmployeeSalesReportItem, HourlySalesReportResponse, OrdersReportDailySummary, SalesByCategoryReportResponse, SalesByItemReportResponse, TableSalesReportItem } from "./response-models/report";

export const getBatchCloseOutReportSummary = (
  from: string,
  to: string,
  appRegisterId?: string,
  employeeId?: string
): Promise<AxiosResponse<BatchCloseOutSummaryResponse>> => {
  let dataUrl =
    ApiUrls.base +
    `/api/v1/report/batch/close-out-summary?from=${from}&to=${to}`;
  if (appRegisterId) {
    dataUrl += `&appRegisterId=${appRegisterId}`;
  }
  if (employeeId) {
    dataUrl += `&employeeId=${employeeId}`;
  }
  return axios.get(dataUrl);
};

export const getDailySalesSummaryReport = (
    from: string,
    to: string,
    appRegisterId?: string,
    employeeId?: string
  ): Promise<AxiosResponse<OrdersReportDailySummary>> => {
    let dataUrl =
      ApiUrls.base +
      `/api/v1/order-sales-report/daily-sales-summary-report?from=${from}&to=${to}`;
    if (appRegisterId) {
      dataUrl += `&appRegisterId=${appRegisterId}`;
    }
    if (employeeId) {
      dataUrl += `&employeeId=${employeeId}`;
    }
    return axios.get(dataUrl);
};
  
export const getBatchReportSummary = (
    from: string,
    to: string,
    appRegisterId?: string,
    employeeId?: string
  ): Promise<AxiosResponse<BatchReportResponse[]>> => {
    let dataUrl =
      ApiUrls.base +
      `/api/v1/report/batch/summary-report?from=${from}&to=${to}`;
    if (appRegisterId) {
      dataUrl += `&appRegisterId=${appRegisterId}`;
    }
    if (employeeId) {
      dataUrl += `&employeeId=${employeeId}`;
    }
    return axios.get(dataUrl);
};
  
export const getSalesItemReportSummary = (
  from: string,
  to: string,
  appRegisterId?: string,
  employeeId?: string,
): Promise<AxiosResponse<SalesByItemReportResponse[]>> => {
  let dataUrl =
    ApiUrls.base +
    `/api/v1/order-sales-report/sales-by-item?from=${from}&to=${to}`;
  if (appRegisterId) {
    dataUrl += `&appRegisterId=${appRegisterId}`;
  }
  if (employeeId) {
    dataUrl += `&employeeId=${employeeId}`;
  }
  
  return axios.get(dataUrl);
}

export const getCategorySalesReportSummary = (
  from: string,
  to: string,
  appRegisterId?: string,
  employeeId?: string,
): Promise<AxiosResponse<SalesByCategoryReportResponse[]>> => {
  let dataUrl =
    ApiUrls.base +
    `/api/v1/order-sales-report/sales-by-category?from=${from}&to=${to}`;
  if (appRegisterId) {
    dataUrl += `&appRegisterId=${appRegisterId}`;
  }
  if (employeeId) {
    dataUrl += `&employeeId=${employeeId}`;
  }
  
  return axios.get(dataUrl);
}

export const getHourlySalesReportSummary = (
  from: string,
  to: string,
  appRegisterId?: string,
  employeeId?: string,
): Promise<AxiosResponse<HourlySalesReportResponse[]>> => {
  let dataUrl =
    ApiUrls.base +
    `/api/v1/order-sales-report/sales-by-hour?from=${from}&to=${to}`;
  if (appRegisterId) {
    dataUrl += `&appRegisterId=${appRegisterId}`;
  }
  if (employeeId) {
    dataUrl += `&employeeId=${employeeId}`;
  }
  
  return axios.get(dataUrl);
}

export const getEmployeeSalesReportSummary = (
  from: string,
  to: string,
  appRegisterId?: string,
  employeeId?: string,
): Promise<AxiosResponse<EmployeeSalesReportItem[]>> => {
  let dataUrl =
    ApiUrls.base +
    `/api/v1/order-sales-report/sales-by-employee?from=${from}&to=${to}`;
  if (appRegisterId) {
    dataUrl += `&appRegisterId=${appRegisterId}`;
  }
  if (employeeId) {
    dataUrl += `&employeeId=${employeeId}`;
  }
  
  return axios.get(dataUrl);
}

export const getTableSalesReport = (
  from: string,
  to: string,
  appRegisterId?: string,
): Promise<AxiosResponse<TableSalesReportItem[]>> => {
  let dataUrl =
    ApiUrls.base +
    `/api/v1/order-sales-report/sales-by-table?from=${from}&to=${to}`;
  if (appRegisterId) {
    dataUrl += `&appRegisterId=${appRegisterId}`;
  }
  
  
  return axios.get(dataUrl);
}